export const NO_GROUP_FILTER_VALUE = "__no_group__";

export function likeFilter(field: string, value: string): string {
  return `${field}=like=${JSON.stringify(value)}`;
}

export function eqFilter(field: string, value: string): string {
  return `${field}==${JSON.stringify(value)}`;
}

export function isNullEqFilter(field: string): string {
  return `${field}==null`;
}

export function joinAnd(filters: string[]): string | undefined {
  const parts = filters.filter((f) => f.trim() !== "");
  return parts.length > 0 ? parts.join(";") : undefined;
}

export function joinOr(filters: string[]): string | undefined {
  const parts = filters.filter((f) => f.trim() !== "");
  return parts.length > 0 ? parts.join(",") : undefined;
}
